import api from './index'

export default {

    /**
     * Export a sample file for a given group and type
     * @param groupId
     * @param type
     * @param params
     */
    getSampleFile(groupId, type, params) {
        return api
            .get(`/export/${groupId}/sample/${type}`, {
                params: params,
                responseType: 'arraybuffer'
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Export the list of users in a group
     * @param groupId
     * @param params
     */
    getUsers(groupId, params) {
        return api
            .get(`/export/${groupId}/users`, {
                params: params,
                responseType: 'arraybuffer'
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Export the wallet transactions of a group
     * @param groupId
     * @param params
     */
    getWalletTransactions(groupId, params) {
        return api
            .get(`/export/${groupId}/wallet_transactions`, {
                params: params,
                responseType: 'arraybuffer'
            })
            .then(response => {
                return response.data
            })
    }

}
